import { AiOutlineDollar } from 'react-icons/ai';
import { BiCheckShield, BiShieldPlus } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa6';
import { IoPawOutline } from 'react-icons/io5';
import { LiaPiggyBankSolid } from 'react-icons/lia';
import { PiMoney, PiTruckLight, PiUserCirclePlusLight } from 'react-icons/pi';

import ApplyNowBackground from '../assets/ApplyNowBackground.webp';
import Button from '../helpers/Button';
import classes from './Apply.module.css';
import vacationIcon from '../assets/icons/vaction.svg';

export default function Apply() {
  return (
    <>
      <div className={classes.applyPage} id='aboveTheFold'>
        <img
          src={ApplyNowBackground}
          alt='Semi-truck with the BBI Transportation logo on the side'
        />
        <div>Are you looking for new opportunities?</div>
        <div className={classes.title}>
          <h1>NOW HIRING</h1>
          <h1>COMPANY DRIVERS</h1>
        </div>
        <Button
          onClick={() =>
            window.open(
              'https://recruiting.paylocity.com/recruiting/jobs/All/9c232b6b-d448-4861-b27b-bf7f955622f5/Hemphill-Son-Co',
              '_blank',
            )
          }
        >
          Join our team
        </Button>
        <div className={classes.requirementsContainer}>
          <div className={classes.requirement}>
            <h3>Experience</h3>
            <ul>
              <li>
                <FaCheck />
                <p>3+ years CDL A required</p>
              </li>
              <li>
                <FaCheck />
                <div>
                  <p>Clean driving record:</p>
                  <p>- No more than 2 accidents in the last 3 years</p>
                  <p>- No more than 3 minor violations in the last 3 years</p>
                  <p>- No major violations in the last 5 years</p>
                </div>
              </li>
            </ul>
          </div>
          <div className={classes.requirement}>
            <h3>Age Requirements</h3>
            <ul>
              <li>
                <FaCheck />
                <p>Between 23-65 (65+ must provide DOT long form)</p>
              </li>
              <li>
                <FaCheck />
                <p>Must meet insurance guidelines</p>
              </li>
              <li>
                <FaCheck />
                <p>Valid driver's license & medical cert</p>
              </li>
            </ul>
          </div>
          <div className={classes.requirement}>
            <h3>Safety Standards</h3>
            <ul>
              <li>
                <FaCheck />
                <p>No drug test failures</p>
              </li>
              <li>
                <FaCheck />
                <p>Prioritizes safety and communication</p>
              </li>
              <li>
                <FaCheck />
                <p>Maintains professional demeanor on the road</p>
              </li>
              <li>
                <FaCheck />
                <p>Adheres to all DOT/FMCSA regulations</p>
              </li>
              <li>
                <FaCheck />
                <p>Performs regular equipment checks</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={classes.benefitsContainer}>
        <h2>Benefits</h2>
        <div className={classes.benefits}>
          <ul>
            <li>
              <PiMoney />
              <p>Competitive Compensation</p>
            </li>
            <li>
              <LiaPiggyBankSolid />
              <p>401K with Company Match</p>
            </li>
            <li>
              <img src={vacationIcon} alt='vacation icon' />
              <p>Driver Vacation Pay</p>
            </li>
            <li>
              <AiOutlineDollar />
              <p>Weekly Paychecks</p>
            </li>
            <li>
              <IoPawOutline />
              <p>Passenger and Pet Programs</p>
            </li>
            <li>
              <PiUserCirclePlusLight />
              <p>Referral Bonus</p>
            </li>
            <li>
              <PiTruckLight />
              <p>Modern Equipment</p>
            </li>
            <li>
              <BiShieldPlus />
              <p>Medical, Dental, and Vision Insurance</p>
            </li>
            <li>
              <BiCheckShield />
              <p>Safety Initiatives</p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
